<script>
// import StarFlightCanvas from "../components/StarFlightCanvas.vue";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export default {
    // components: { StarFlightCanvas },
    name: "",

    mounted() {
        // const flightPath = {
        //     curviness: 1.25,
        //     autoRotate: true,
        //     values: [{ x: 100, y: -20 }],
        // };

        gsap.registerPlugin(ScrollTrigger);

        let textTl = gsap
            .timeline({
                scrollTrigger: {
                    trigger: ".hero",
                    toggleActions: "restart pause resume pause",
                    start: "top top",
                    scrub: 1,
                    pin: true,
                },
            })
            .to(".main-headline", {
                y: "-70%",
                width: "100%",
                duration: 1,
            }, 0)
            .to(".main-explainer", {
                opacity: 0,
                y: "-10%",
                duration: 0.5,
            });

        textTl
            .to("#role-developer", {
                x: "-50%",
                duration: 2,
            })
            .to(".paper-plane", {
                x: 500,
                y: 200,
            });
        gsap.timeline({
            scrollTrigger: {
                trigger: ".animation",
                toggleActions: "restart pause resume pause",
                start: "top top",
                scrub: 1,
                pin: true,
            },
        })
            .to(".paper-plane", {
                x: 500,
                duration: 2,
            })
            .to(".paper-plane", {
                x: 500,
                y: 200,
            });
    },
};
</script>

<template>
    <div class="h-full">
        <!-- <star-flight-canvas class="hidden absolute h-full bg-green-400" /> -->

        <div class="hero h-full bg-bleu text-white flex justify-center items-center">
            <div class="grid gap-5 h-full grid-cols-12 mx-auto md:w-11/12 lg:w-10/12 xl:w-9/12 2xl:w-8/12">
                <div class="text-left col-span-6 flex flex-col gap-3 justify-center items-start bg-purple-200">
                    <h2 class="main-headline bg-green-400 text-6xl font-black uppercase">
                        Main
                        <span class="text-orange"> headline </span>
                    </h2>
                    <p class="main-explainer text-lg bg-blue-400">
                        <!-- Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi quod eos, nulla aliquid porro eum officiis esse mollitia saepe dicta ad veritatis nostrum -->
                        Explainer
                    </p>
                    <a href="" class="main-cta rounded font-bold uppercase bg-orangé px-3 py-2"> Main Call to Action </a>
                </div>

                <div class="roles-container relative col-span-6 flex justify-center items-end bg-yellow-200">
                    <div id="role-developer" class="role absolute cursor-pointer h-4/5 w-52 bg-green-200">
                        <!-- <img class="h-full w-auto" src="/images/developer.svg" alt="" /> -->
                    </div>
                    <div id="role-designer" class="role absolute cursor-pointer h-4/5 w-52 bg-red-200">
                        <!-- <img class="h-full w-auto" src="/images/designer.svg" alt="" /> -->
                    </div>
                    <div id="role-manager" class="role absolute cursor-pointer h-4/5 w-52 bg-pink-200">
                        <!-- <img class="h-full w-auto" src="/images/manager.svg" alt="" /> -->
                    </div>
                </div>
            </div>
        </div>

        <section class="animation h-full relative">
            <img class="paper-plane absolute left-0 top-1/2 w-24" src="/img/zeromalaria/artwork_small_en/1.jpg" alt="" />
        </section>

        <footer class="h-full bg-red-200 flex justify-center items-center">
            <h2>Footer</h2>
        </footer>
        <div class="hidden h-full grid-cols-12 mx-auto md:w-11/12 lg:w-10/12 xl:w-9/12 2xl:w-8/12">
            <div class="text-left col-span-4 flex flex-col gap-3 justify-center items-start">
                <h2 class="text-6xl font-bold">Enterprise Software</h2>
                <p class="text-lg">
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Nisi quod eos, nulla aliquid porro eum officiis esse mollitia saepe dicta ad veritatis nostrum ullam
                    assumenda repellat consequuntur excepturi harum hic.
                </p>
                <a href="" class="rounded bg-red-500 px-3 py-2"> Call to action </a>
            </div>
            <div class="col-span-2"></div>

            <div class="roles-container relative col-span-6 flex justify-center items-end">
                <div id="role-developer" class="role absolute cursor-pointer h-4/5">
                    <!-- <img class="h-full w-auto" src="/images/developer.svg" alt="" /> -->
                    <svg class="h-full w-auto" width="714" height="773" viewBox="0 0 714 773" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            id="developer-shadow"
                            class="role-shadow"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M351.519 106.765C351.519 119.189 349.388 131.116 345.473 142.199C391.261 153.518 431.793 184.521 453.637 230.435L648.689 640.408C687.365 721.699 652.818 818.952 571.527 857.627L564.871 860.794C483.58 899.47 386.328 864.923 347.652 783.632L228.015 532.172H82.5717L0.762695 385.938H158.442L152.6 373.659C122.866 311.163 136.411 239.232 181.202 191.738C155.458 172.328 138.815 141.49 138.815 106.765C138.815 48.0288 186.431 0.413574 245.167 0.413574C303.903 0.413574 351.519 48.0288 351.519 106.765Z"
                            fill="white"
                        />
                        <rect x="91" y="224.057" width="326" height="762.761" rx="163" transform="rotate(-25.4436 91 224.057)" fill="#C19F9F" />
                        <circle cx="250" cy="107" r="104" fill="#D9D9D9" />
                        <path d="M10.999 379.997H337.999L417.999 522.997H90.999L10.999 379.997Z" fill="#D9D9D9" />
                    </svg>
                </div>
                <div id="role-designer" class="role absolute cursor-pointer h-4/5">
                    <!-- <img class="h-full w-auto" src="/images/designer.svg" alt="" /> -->
                    <svg class="h-full w-auto" width="429" height="820" viewBox="0 0 429 820" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                            id="designer-shadow"
                            class="role-shadow"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M334.184 163.979C349.804 148.562 359.856 127.428 360.861 103.771C362.969 54.1228 324.43 12.1655 274.782 10.057C225.133 7.94848 183.176 46.4872 181.068 96.1356C180.438 110.972 183.437 125.121 189.278 137.725C125.15 153.832 74.6997 208.291 66.9707 277.866L15.8665 737.902C5.92732 827.374 70.4014 907.962 159.873 917.902L170.962 919.133C260.434 929.073 341.023 864.599 350.962 775.127L402.066 315.091C402.124 314.568 402.18 314.045 402.233 313.522L464.562 292.021L448.036 244.114L399.064 261.008C398.298 257.632 397.426 254.293 396.452 250.993L449.706 205.728L418.808 169.377L375.413 206.262C364.389 189.853 350.428 175.486 334.184 163.979Z"
                            fill="white"
                        />
                        <rect x="364.627" y="217.648" width="56" height="44" transform="rotate(-40.9977 364.627 217.648)" fill="#20AE40" />
                        <rect x="85.186" y="127.211" width="326" height="762.761" rx="163" transform="rotate(6.33886 85.186 127.211)" fill="#898787" />
                        <circle cx="265.028" cy="111.828" r="87" transform="rotate(2.43182 265.028 111.828)" fill="#D9D9D9" />
                        <rect x="286.83" y="281.93" width="159" height="46.1294" transform="rotate(-40.364 286.83 281.93)" fill="#D9D9D9" />
                        <rect x="285.932" y="303.07" width="159" height="49" transform="rotate(-19.0329 285.932 303.07)" fill="#D9D9D9" />
                    </svg>
                </div>
                <div id="role-manager" class="role absolute cursor-pointer h-4/5">
                    <!-- <img class="h-full w-auto" src="/images/manager.svg" alt="" /> -->
                    <svg width="451" height="860" class="h-full w-auto" viewBox="0 0 451 860" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <mask id="path-1-inside-1_1181_33" fill="white">
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M357.885 178.723C371.003 160.242 378.715 137.653 378.715 113.264C378.715 50.7335 328.024 0.0424805 265.493 0.0424805C202.963 0.0424805 152.272 50.7335 152.272 113.264C152.272 134.453 158.092 154.282 168.222 171.241C147.606 187.668 131.127 208.975 120.425 233.477L98.0294 284.751C95.726 290.025 92.9687 295.088 89.7885 299.884L48.364 362.354C23.4299 399.955 49.4718 450.323 94.5678 451.716V736.958C94.5678 826.98 167.545 899.958 257.568 899.958H270.161C360.183 899.958 433.161 826.98 433.161 736.958V462.18V384.563V332.677L376.036 188.779L357.885 178.723Z"
                            />
                        </mask>
                        <path
                            id="manager-shadow"
                            class="role-shadow"
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M357.885 178.723C371.003 160.242 378.715 137.653 378.715 113.264C378.715 50.7335 328.024 0.0424805 265.493 0.0424805C202.963 0.0424805 152.272 50.7335 152.272 113.264C152.272 134.453 158.092 154.282 168.222 171.241C147.606 187.668 131.127 208.975 120.425 233.477L98.0294 284.751C95.726 290.025 92.9687 295.088 89.7885 299.884L48.364 362.354C23.4299 399.955 49.4718 450.323 94.5678 451.716V736.958C94.5678 826.98 167.545 899.958 257.568 899.958H270.161C360.183 899.958 433.161 826.98 433.161 736.958V462.18V384.563V332.677L376.036 188.779L357.885 178.723Z"
                            fill="white"
                        />
                        <path
                            d="M446.309 450.66L446.807 450.71L446.807 450.71L446.309 450.66ZM450.902 405.329L451.4 405.379L451.4 405.379L450.902 405.329ZM446.807 450.71L451.4 405.379L450.405 405.278L445.812 450.609L446.807 450.71ZM451.4 405.379C452.514 394.382 444.225 384.68 433.189 384.064L433.133 385.062C443.6 385.646 451.462 394.848 450.405 405.278L451.4 405.379ZM445.812 450.609C445.16 457.045 439.641 461.88 433.176 461.68L433.145 462.679C440.135 462.895 446.102 457.668 446.807 450.71L445.812 450.609ZM357.885 178.723L357.069 178.145L356.422 179.056L357.4 179.598L357.885 178.723ZM168.222 171.241L168.845 172.023L169.529 171.478L169.08 170.728L168.222 171.241ZM120.425 233.477L121.342 233.878L121.342 233.878L120.425 233.477ZM98.0294 284.751L97.113 284.351L97.113 284.351L98.0294 284.751ZM89.7885 299.884L88.9551 299.331L88.9551 299.331L89.7885 299.884ZM48.364 362.354L49.1974 362.906L49.1974 362.906L48.364 362.354ZM94.5678 451.716H95.5678V450.747L94.5987 450.717L94.5678 451.716ZM433.161 332.677H434.161V332.486L434.09 332.308L433.161 332.677ZM376.036 188.779L376.966 188.41L376.834 188.077L376.521 187.904L376.036 188.779ZM377.715 113.264C377.715 137.439 370.071 159.826 357.069 178.145L358.7 179.302C371.935 160.657 379.715 137.868 379.715 113.264H377.715ZM265.493 1.04248C327.472 1.04248 377.715 51.2857 377.715 113.264H379.715C379.715 50.1812 328.576 -0.95752 265.493 -0.95752V1.04248ZM153.272 113.264C153.272 51.2857 203.515 1.04248 265.493 1.04248V-0.95752C202.411 -0.95752 151.272 50.1812 151.272 113.264H153.272ZM169.08 170.728C159.041 153.92 153.272 134.267 153.272 113.264H151.272C151.272 134.638 157.144 154.645 167.363 171.754L169.08 170.728ZM167.599 170.459C146.856 186.987 130.277 208.425 119.509 233.077L121.342 233.878C131.978 209.526 148.355 188.35 168.845 172.023L167.599 170.459ZM119.509 233.077L97.113 284.351L98.9458 285.151L121.342 233.878L119.509 233.077ZM97.113 284.351C94.8328 289.571 92.1033 294.583 88.9551 299.331L90.6219 300.436C93.8341 295.592 96.6192 290.478 98.9458 285.151L97.113 284.351ZM88.9551 299.331L47.5306 361.801L49.1974 362.906L90.6219 300.436L88.9551 299.331ZM47.5306 361.801C22.1634 400.056 48.6576 451.298 94.5369 452.716L94.5987 450.717C50.286 449.347 24.6964 399.855 49.1974 362.906L47.5306 361.801ZM93.5678 451.716V736.958H95.5678V451.716H93.5678ZM93.5678 736.958C93.5678 827.532 166.993 900.958 257.568 900.958V898.958C168.098 898.958 95.5678 826.428 95.5678 736.958H93.5678ZM257.568 900.958H270.161V898.958H257.568V900.958ZM270.161 900.958C360.735 900.958 434.161 827.533 434.161 736.958H432.161C432.161 826.428 359.631 898.958 270.161 898.958V900.958ZM434.161 736.958V462.18H432.161V736.958H434.161ZM434.161 462.18V384.563H432.161V462.18H434.161ZM434.161 384.563V332.677H432.161V384.563H434.161ZM434.09 332.308L376.966 188.41L375.107 189.147L432.231 333.046L434.09 332.308ZM376.521 187.904L358.37 177.849L357.4 179.598L375.552 189.653L376.521 187.904Z"
                            fill="black"
                            mask="url(#path-1-inside-1_1181_33)"
                        />
                        <circle cx="267" cy="111" r="104" fill="#D9D9D9" />
                        <path
                            d="M289.859 314.523C255.489 279.101 239.02 230.012 245.072 181.028M262.325 142.275C258.364 137.417 250.614 139.491 249.478 145.5M443.081 412.933C444.11 402.785 436.6 393.812 426.5 392.974M438.66 456.553C438.024 462.834 432.76 467.594 426.5 467.65M424.339 340.172L267.388 147.694L370.601 204.851L424.339 340.172ZM425.5 467.129L100.015 457.074C56.9926 455.745 32.1508 407.69 55.9441 371.82L95.8152 311.713C98.8931 307.073 101.562 302.174 103.791 297.072L124.435 249.825C140.196 213.754 168.514 184.631 204.128 167.865L248.792 146.839L244.576 180.967C238.505 230.101 255.024 279.34 289.5 314.871L333.141 359.848L333.859 359.152L290.218 314.175C255.953 278.861 239.535 229.923 245.568 181.09L249.842 146.5H265.125L425.5 343.178V392.411L122.528 375.501L122.472 376.499L425.5 393.412V467.129ZM425.5 468.13V726C425.5 815.746 352.746 888.5 263 888.5C173.254 888.5 100.5 815.746 100.5 726V458.089L425.5 468.13Z"
                            fill="#3D589C"
                            stroke="black"
                        />
                    </svg>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
#app {
    height: 100vh;
}

.roles-container:hover .role {
    transform: scale(1.1);
}
/* .roles-container:hover #role-designer {
    transform: rotate(15deg) translate(20%, 0) scale(1.05);
}
.roles-container:hover #role-developer {
    transform: rotate(-5deg) translate(-20%, 0) scale(1.05);
} */

.role {
    transition: 0.3s ease-out;
    transform-origin: bottom;
}
.role .role-shadow {
    display: none;
}
#role-designer {
    transform: rotate(5deg) translate(10%, 0);
}
#role-developer {
    transform: rotate(0deg) translate(-10%, 0);
}
#role-designer:hover {
    transform: rotate(10deg) translate(20%, 0);
}
#role-manager:hover {
    /* transform: scale(1.15); */
}
#role-developer:hover {
    transform: rotate(10deg) translate(-20%, 0);
}
.role:hover {
    transform: scale(1.2);
}
.role:hover .role-shadow {
    display: block;
}
</style>
